export default __webpack_public_path__ + "static/gantvarsity-sans-regular-dc95066d76a4eb833fe362245470b0d6.woff";